import { SavingsCalculator } from '@components/savings-calculator/savings-calculator';

export const SavingsCalculatorOpenPagesWidget = () => <SavingsCalculator />;
